module.exports = __webpack_public_path__ + "img/Gansu-power.5e394723.png";